// chat
export const GET_ENROLLMENT = "/enrollments/active";
export const SEND_MESSAGE_CODE = "/chat";
export const LOGIN = "/auth/login";
